import React, { useEffect, useState } from 'react'
import CouponBox from '../../CouponBox'
import CouponConfigurableLabel from '../../CouponConfigurableLabel'
import MarketFilters from './MarketFilters';
import OutletFilters from './OutletFilters';
import { useSelector } from 'react-redux';
import { MarketDetailsSelectorTypes } from '../../../types';
import { applyLocationFilter } from './configData';
import RequiredFieldIndicator from '../../../../../components/popup/requiredField';

/**
 * This is parent component for location(market) filter and outlet filter
 * @param props 
 * @returns 
 */

function MarketDetailsSelector(props:MarketDetailsSelectorTypes) {
    const {handleChange , values , editMode  , getAllOptions , loading,arbitraryList,chipLimit,dataLimit} = props
    const [key , setKey] = useState<number>(0);
    const [outletCurrentTab, setOutletCurrentTab] = useState<number>(0);
    const {outletLevelTabsList} = useSelector((state:any)=>state?.manageCoupons?.configData);
    console.log(values)

    useEffect(()=>{
        if(outletLevelTabsList)
            setKey((pre)=>pre+1);
    },[values.schemeLocationBifurcations])
    
    return (
        <div className="market-filter-outlet-filter-wrapper">
            {
                applyLocationFilter() && <CouponBox collapsible header={<CouponConfigurableLabel text={'market-filter'} style={{ color: 'inherit' }} />}>
                <MarketFilters 
                    arbitraryList={arbitraryList}
                    editMode={editMode}
                    handleChange={handleChange} 
                    values={values} 
                    getMarketOptions={getAllOptions}
                    loading={loading.market}
                    multiple={true}
                />
            </CouponBox>
            }
            <CouponBox collapsible header={<CouponConfigurableLabel text={'outlet-filter'} style={{ color: 'inherit' }} />}>
                <OutletFilters
                    arbitraryList={arbitraryList}
                    key={`outlet-filter-${key}`}
                    outletLevelTabsList={outletLevelTabsList}
                    editMode={editMode}
                    outletCurrentTab={outletCurrentTab}
                    setOutletCurrentTab={setOutletCurrentTab}
                    handleChange={handleChange} 
                    values={values} 
                    getOutletOptions={getAllOptions}   
                    loading={loading.outlet} 
                    multiple={true}
                    chipLimit={chipLimit}
                    dataLimit={dataLimit}
                />
            </CouponBox>
        </div>
    )
}

export default MarketDetailsSelector